import { Form, Typography } from "antd";
import { Tooltip } from "antd-v5";
import { useForm } from "antd/lib/form/Form";
import { InfoIcon } from "components/Icons";
import {
  FeatureFlagContentValuesType,
  useFeatureFlag,
} from "contexts/FeatureFlagContext";
import _, { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { FieldTypes, generateFormFields } from "utils/formUtils";

// export enum AUTO_CREATE_GIT_TOOL_CONFIG {
//   DEPENDABOT = "DEPENDABOT",
//   GITHUB_CODE_SCAN = "GITHUB_CODE_SCAN",
//   GITHUB_SECRET_SCAN = "GITHUB_SECRET_SCAN",
// }

export enum GIT_TOOL_MAPPING_CONFIG {
  // MAP_ARCHIVE_REPOS = "ARCHIVED",
  MAP_INACTIVE_REPOS = "INACTIVE",
  MAP_DORMANT_REPOS = "DORMANT",
  WEBHOOK = "webhookEnabled",
  MAP_GITHUB_ISSUES = "githubIssuesEnabled",
  INGEST_COMPONENTS = "ingestComponents",
}

const optionsToMapAdditionalRepos = (
  toolName: string,
  featureFlags: FeatureFlagContentValuesType,
) => {
  return [
    // {
    //   label: "Map Archived Repos",
    //   value: GIT_TOOL_MAPPING_CONFIG.MAP_ARCHIVE_REPOS,
    //   checked: false,
    // },
    ...(featureFlags.SIMPLIFIED_ONBOARDING
      ? [
          {
            label: (
              <>
                Map Inactive Repos
                <Tooltip title="You can customize definition of active and dormant settings under Global Settings->Configuration->Repository Settings">
                  <InfoIcon className="m-l-xs" />
                </Tooltip>
              </>
            ),
            value: GIT_TOOL_MAPPING_CONFIG.MAP_INACTIVE_REPOS,
            checked: false,
          },
          {
            label: (
              <>
                Map Dormant Repos
                <Tooltip title="You can customize definition of active and dormant settings under Global Settings->Configuration->Repository Settings">
                  <InfoIcon className="m-l-xs" />
                </Tooltip>
              </>
            ),
            value: GIT_TOOL_MAPPING_CONFIG.MAP_DORMANT_REPOS,
            checked: false,
          },
        ]
      : []),
    ...(toolName === "GITLAB"
      ? [
          {
            label: "Map Archived Repos",
            value: "mapArchived",
            checked: false,
          },
        ]
      : []),
    ...(toolName === "GitHub" && featureFlags.GITHUB_ISSUES_CONFIG
      ? [
          {
            label: "Map Github Issues for all Repos",
            value: GIT_TOOL_MAPPING_CONFIG.MAP_GITHUB_ISSUES,
            checked: false,
          },
        ]
      : []),
    ...(toolName === "GitHub" && featureFlags.MANAGE_SBOM
      ? [
          {
            label: "Ingest Components",
            value: GIT_TOOL_MAPPING_CONFIG.INGEST_COMPONENTS,
            checked: false,
          },
        ]
      : []),
  ];
};

// const toolConfigMappingsIntialValues = [
//   {
//     label: "Github Dependabot",
//     value: AUTO_CREATE_GIT_TOOL_CONFIG.DEPENDABOT,
//     checked: false,
//   },
//   {
//     label: "Github Code Scan",
//     value: AUTO_CREATE_GIT_TOOL_CONFIG.GITHUB_CODE_SCAN,
//     checked: false,
//   },
//   {
//     label: "Github Secret Scan",
//     value: AUTO_CREATE_GIT_TOOL_CONFIG.GITHUB_SECRET_SCAN,
//     checked: false,
//   },
// ];

export type Values = {
  [x in GIT_TOOL_MAPPING_CONFIG]: boolean;
} & {
  codeClassificationEnabled?: boolean;
};

type Props = {
  onChange: ((changedValues: any, values: any) => void) | undefined;
  values?: Values;
  hostingType?: string;
  toolName?: string;
};

const AutoMappingSettingsForm = ({
  onChange,
  values,
  toolName = "",
}: Props) => {
  const [form] = useForm();
  const featureFlags = useFeatureFlag();

  const initialValues = values || {
    ..._.map(
      optionsToMapAdditionalRepos(toolName, featureFlags),
      (entry: any) => ({
        [entry.value]: entry.checked,
      }),
    ),
  };

  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    }
  }, [form, values]);

  const fields = optionsToMapAdditionalRepos(toolName, featureFlags);

  if (isEmpty(fields)) {
    return null;
  }

  return (
    <div className="m-b-m">
      <div className="m-y-sm">
        <Typography.Text strong style={{ fontSize: 15 }}>
          Settings
        </Typography.Text>
      </div>
      <Form
        initialValues={initialValues}
        onValuesChange={onChange}
        layout="vertical"
      >
        <Typography.Text strong>
          Options to map additional repos
        </Typography.Text>
        {generateFormFields(
          _.map(fields, (entry: any) => {
            return {
              name: entry.value,
              className: "m-b-0",
              inline: true,
              label: entry.label,
              type: FieldTypes.BOOLEAN,
            };
          }),
        )}
        {/* <div className='m-t-l'><Typography.Text strong>Using GitHub Advanced Security<Tooltip title="Automatically map GitHub Advanced Security tools when these features are found enabled on a repo."><InfoIcon className='m-l-xs' /></Tooltip></Typography.Text></div>
        {generateFormFields(_.map(toolConfigMappingsIntialValues, entry => {
          return {
            name: entry.value,
            className: "m-b-0",
            label: entry.label,
            type: FieldTypes.BOOLEAN
          }
        }))} */}
      </Form>
    </div>
  );
};

export default AutoMappingSettingsForm;
